module.exports = __webpack_public_path__ + "static/Sergei-blur-over-785cac81828f4d7bacb73e6f2f293033.jpg";